import styled, {
  boxShadows,
  breakpoints,
  Button,
  css,
  Device,
  FloatingMessage,
  IFalconTheme,
  ResponsiveTypography,
  Scale,
  StyledComponent,
} from '@se-admin/falcon';

const LineItemContainer: StyledComponent<'div', {}, {}> = styled('div')`
  margin: ${Scale.xxxs} 0;
`;

const InlineLineItemContainer: StyledComponent<'div', {}, {}> = styled('div')`
  margin: ${Scale.xxxs} 0 ${Scale.xxxs} ${Scale.m};
`;

const TipContainer: StyledComponent<'div', IFalconTheme, {}> = styled('div')(
  ({ theme }: { theme: IFalconTheme }) => {
    return css`
      display: flex;
      flex-direction: column;
      background: ${theme.color.smart05};
      border-left: ${Scale.xxxs} solid ${theme.color.smart30};
      padding: ${Scale.xs};
      margin-top: ${Scale.l};
    `;
  }
);

const EnticementContainer: StyledComponent<'div', {}, {}> = styled('div')`
  display: block;
  text-align: center;
  margin-top: ${Scale.m};
`;

const RedirectButton: StyledComponent<typeof Button, {}, {}> = styled(Button)`
  margin-bottom: ${Scale.l};
`;

const StyledButton: StyledComponent<typeof Button, {}, {}> = styled(Button)`
  margin-bottom: ${Scale.m};
`;

const StyledFullWidthButton: StyledComponent<typeof Button, {}, {}> = styled(Button)`
  margin-bottom: ${Scale.m};
  width: 100%;
`;

const StyledFloatingMessage: StyledComponent<typeof FloatingMessage, {}, {}> = styled(
  FloatingMessage
)`
  width: 100%;
`;

const BackButton: StyledComponent<typeof Button, {}, {}> = styled(Button)`
  padding: ${Scale.xxs} ${Scale.xs} ${Scale.xs} 0;
  margin-bottom: ${Scale.xs};
  background: none !important;
  box-shadow: none !important;
  &:focus {
    div {
      box-shadow: ${boxShadows.active};
    }
  }
  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
    text-decoration: underline;
  }
  @media only screen and (max-width: ${breakpoints[Device.tablet]}) {
    margin-top: ${Scale.m};
    width: 100%;
  }
`;

const OptionsButton: StyledComponent<typeof Button, {}, {}> = styled(Button)`
  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
    width: fit-content;
    margin: ${Scale.s} 0;
  }
  @media only screen and (max-width: ${breakpoints[Device.tablet]}) {
    width: 100%;
  }
  height: fit-content;
`;

const StyledTypography: StyledComponent<typeof ResponsiveTypography, {}, {}> = styled(
  ResponsiveTypography
)`
  margin-bottom: ${Scale.m};
`;

const ExplanationTypography: StyledComponent<typeof ResponsiveTypography, {}, {}> = styled(
  ResponsiveTypography
)`
  margin-bottom: ${Scale.xl};
`;

const InlineResponsiveTypography: StyledComponent<typeof ResponsiveTypography, {}, {}> = styled(
  ResponsiveTypography
)`
  display: inline;
`;

const PriceBreakdown: StyledComponent<'div', {}, {}> = styled('div')`
  margin-top: ${Scale.m};
`;

const BreakdownSection: StyledComponent<'div', {}, {}> = styled('div')`
  @media (min-width: ${breakpoints[Device.desktop]}) {
    padding: 0 0 ${Scale.l};
  }
`;

const HorizontalSeparator: StyledComponent<'hr', IFalconTheme, {}> = styled('hr')(
  ({ theme }: { theme: IFalconTheme }) => {
    return css`
      margin: ${Scale.m} 0;
      border-top: 1px solid ${theme.color.grey50};
    `;
  }
);

export {
  StyledTypography,
  TipContainer,
  EnticementContainer,
  StyledButton,
  StyledFullWidthButton,
  StyledFloatingMessage,
  PriceBreakdown,
  RedirectButton,
  OptionsButton,
  InlineLineItemContainer,
  InlineResponsiveTypography,
  BackButton,
  ExplanationTypography,
  HorizontalSeparator,
  LineItemContainer,
  BreakdownSection,
};
